var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 13,
    viewBox: "0 0 3 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50065 1.50002C2.50065 1.96026 2.12756 2.33335 1.66732 2.33335C1.20708 2.33335 0.833984 1.96026 0.833984 1.50002C0.833984 1.03978 1.20708 0.666687 1.66732 0.666687C2.12756 0.666687 2.50065 1.03978 2.50065 1.50002ZM2.50065 6.16669C2.50065 6.62692 2.12756 7.00002 1.66732 7.00002C1.20708 7.00002 0.833984 6.62692 0.833984 6.16669C0.833984 5.70645 1.20708 5.33335 1.66732 5.33335C2.12756 5.33335 2.50065 5.70645 2.50065 6.16669ZM2.50065 10.8334C2.50065 11.2936 2.12756 11.6667 1.66732 11.6667C1.20708 11.6667 0.833984 11.2936 0.833984 10.8334C0.833984 10.3731 1.20708 10 1.66732 10C2.12756 10 2.50065 10.3731 2.50065 10.8334Z",
    fill: "#929298",
    stroke: "#929298"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.370d0f9cbae057e5b55083b00ff32164.svg";
export { ForwardRef as ReactComponent };